// Explicit synthetic preview data. Never used as component defaults.
import { ART_BASE } from '../assets.js';

export const FIXTURE_PROFILES = [
  { id: 'sara', name: 'Sara', avatar: `${ART_BASE}/avatar-parent-1.jpg`, authMethod: 'password', email: 'sara@silvafamily.cm' },
  { id: 'david', name: 'David', avatar: `${ART_BASE}/avatar-parent-2.jpg`, authMethod: 'password', email: 'david@silvafamily.cm' },
  { id: 'maya', name: 'Maya', avatar: `${ART_BASE}/avatar-kid-1.jpg`, authMethod: 'pin', pinLength: 4 },
  { id: 'leo', name: 'Leo', avatar: `${ART_BASE}/avatar-kid-2.jpg`, authMethod: 'pin', pinLength: 4 },
  { id: 'finn', name: 'Finn', avatar: `${ART_BASE}/avatar-kid-3.jpg`, authMethod: 'open' },
];

export const loginFixture = {
  profiles: FIXTURE_PROFILES,
  familyName: 'Silva',
};
